const interfaceConfig = {
  loginImage: '/images/hawaii-images/couple.jpg',
  signupImage: '/images/hawaii-images/man_guitar.jpg',
  signupReasons: '',
  orgName: 'Purpose Pals',
};

export default interfaceConfig;
